import React from 'react';

const SectionDivider: React.FC = () => {
  return (
    <div className="w-full border-t border-white/10"></div>
  );
};

export default SectionDivider;
